﻿/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
//import 'devextreme/dist/css/dx.light.css';
import ContextMenu from 'devextreme-react/context-menu';
import Button from 'devextreme-react/button';
import DataGrid, {
    Scrolling, Editing, Form, Column, Paging, SearchPanel, HeaderFilter, FilterRow, Selection, Export,
    FilterBuilderPopup, Popup, Toolbar as GToolbar, Item as GToolbarItem, Sorting, Grouping,
    StateStoring as GStateStoring, FilterPanel as GFilterPanel
} from 'devextreme-react/data-grid';
import { Workbook } from 'devextreme-exceljs-fork';
import { saveAs } from 'file-saver-es';
import { exportDataGrid as exportDataGridToExcel } from 'devextreme/excel_exporter';
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';

import TreeList, {
    Toolbar as TToolbar,
    Item as TToolbarItem,
    StateStoring as TStateStoring, FilterPanel as TFilterPanel,
} from 'devextreme-react/tree-list';

import { Item as Form_Item, SimpleItem } from 'devextreme-react/form';
//import { Item as Toolbar_Item } from 'devextreme-react/toolbar';
import { toLowerKeys, apiGetA, apiPostP, apiPostA, apiPutP, apiDeleteP } from '../GanjiTools';
import { ScrollBar } from 'devextreme-react/chart';
//import { DateBox, LoadIndicator, TextBox } from 'devextreme-react';
import TarikhPicker from './TarikhPicker';
import TarikhTimePicker from './TarikhTimePicker';
import UniMetaGrid from './UniMetaGrid';
import { invalidUser_component } from '../commonTools';
import TimePickerHHMM from './TimePicker';
import Spinner from './utils/Spinner';
import localforage from 'localforage';
import Inline from './Inline';
import Header from './layout/Header';
// import '@fortawesome/free-solid-svg-icons';
// import '@fortawesome/fontawesome-free';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CheckBox, Lookup, NumberBox, SelectBox, TextBox } from 'devextreme-react';
import { PageAssigner } from './UniPage';
import FontAwesomeIcon from './utils/FontAwesomeIcon';
import { Document, Page, Text, View, StyleSheet, Font, pdf } from '@react-pdf/renderer';
//import ReactPDF from '@react-pdf/renderer';
import MyGridPdf from './pdf-export/MyGridPdf';
import CarPlate from './utils/CarPlate';
import { formatNumber } from 'devextreme/localization';
import { isMobile } from 'react-device-detect';

// Resolve CommonJS/ESM interop for some devextreme-react components (keep wrappers to ensure React receives components)
const DataGridComp = (typeof DataGrid !== 'undefined' && (DataGrid?.default ?? DataGrid)) || undefined;
const TreeListComp = (typeof TreeList !== 'undefined' && (TreeList?.default ?? TreeList)) || undefined;
const ButtonComp = (typeof Button !== 'undefined' && (Button?.default ?? Button)) || undefined;

function defLookupDataSource(x, state) {
    if (!x)
        return undefined;

    if (Array.isArray(x) && x.length > 0)
        return (
            Object.keys(x[0]).includes('id')
                ?
                {
                    dataSource: x,
                    keyExpr: 'id',
                    valueExpr: 'id',
                    displayExpr: 'summary',
                }
                :
                {
                    dataSource: x
                }
        );

    if (typeof (x) == 'function')
        return x(state);
}

function onExporting(e, fileName = 'report', sheetName = 'data') {
    if (e.format == 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(sheetName);
        exportDataGridToExcel({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer()
                .then(buffer => {
                    saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName + '.xlsx');
                });
        });
        return;
    }

    if (e.format === 'pdf') {
        //ReactPDF.render(<UniGrid table='customer' />, `./example.pdf`);
        // Font.register({
        //     family: "Vazir",
        //     src: "/public/fonts/Vazirmatn-Regular.ttf", // "/public/fonts/IRANSansXRegular.ttf",
        //     //src: "../fonts/IRANSansXRegular.ttf", // "/public/fonts/IRANSansXRegular.ttf",
        // });

        const grid = e.component;

        // Collect visible columns
        const exportColumns = grid.getVisibleColumns().map(col => ({
            name: col.name,
            caption: col.caption,
            dataField: col.dataField,
            alignment: col.alignment,
            width: col.bestFitWidth,
            dataType: col.dataType,
            colSpan: col.colSpan,
            visible: col.visible,
        }));

        // Collect visible rows
        const exportRows = grid.getVisibleRows().map(row =>
            row.cells.map(c => c.text ?? c.displayValue ?? c.value ?? "")
        );

        // Create a PDF blob from the React-PDF Document
        pdf(<MyGridPdf columns={exportColumns} rows={exportRows} />) // title={...}
            .toBlob()
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "./datagrid.pdf";
                link.click();

                // Prevent DevExtreme’s default export
                e.cancel = true;
            })
            .catch(window.notif);
    }
}

// export class UserAccess {
//     gridAccess = 'can_edit'; // hidden, can_view, can_edit, must_edit
//     rowFilter = _ => true;
//     rowMap = r => r;
//     columnAccess = _ => 'can_edit';
// }

export class UniGrid extends React.Component {
    constructor(props) {
        super(props);

        this.selectedKeys = props.selectedKeys;

        this.state = {
            gridKey: 1,
            placeholder: 'جستجو...',
            rtlEnabled: !this.props.ltr,
            contextMenuItems: props.contextMenuItems,
            columns: props.columns, // toLowerKeys(props.columns),
            rows: props.rows ?? props.dataSource,
            loading: true,
            groupBy: this.props.groupBy,
            parentFieldName: this.props.parentFieldName,
            focusedRow: undefined,
            showUniSettings: this.props.showUniSettings,
            topMenuItem: this.props.topMenuItem,
            favKey: 1,
            forceUseGrid: this.props.forceUseGrid === true,
            outerDivKey: 1,
            dontSaveStates: this.props.saveState === false,
        };

        this.saveStates = this.saveStates.bind(this);
        this.loadStates = this.loadStatesA.bind(this);
        this.loadData = this.loadDataA.bind(this);
        this.loadMetaData = this.loadMetaDataA.bind(this);
        this.refineColumns = this.refineColumnsA.bind(this);
        this.onRowUpdating = this.onRowUpdating.bind(this);
        this.onRowInserting = this.onRowInserting.bind(this);
        this.onRowRemoving = this.onRowRemoving.bind(this);
        this.autoUpdateOrInsertToTable = this.autoUpdateOrInsertToTable.bind(this);
        this.sid = props.sid ?? props.title ?? props.id ?? ('t' + Number(new Date()));

        //this.loadStates().then();
        //this.onExporting = this.onExporting.bind(this);
    }

    async loadMetaDataA() {
        if (!this.state.showUniSettings || this.props.noMetaGrid !== false)
            return ({ metarows: [] });

        let tblsid = this.props.table?.length > 0 ? this.props.table : this.props.sid?.length > 0 ? 'sid:' + this.props.sid : '';

        if (!(tblsid?.length > 0))
            return ({ error: 'Sid is null.' }); // throw 'error: no table name!';

        tblsid = tblsid.split('.');
        tblsid = tblsid[tblsid.length - 1];
        let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';
        let res1 = await apiGetA(`/api/${cont}/cols/${tblsid}`);
        // res1 ??= await apiPostA(`/api/${cont}/rows/UniGridSetting?field=TableName&equalTo=${tblsid}`);
        // res1 ??= await apiGetA(`/api/${cont}/rows/Uni.UniGridSetting?field=TableName&equalTo=${tblsid}`);
        let metaRows = res1?.[res1._rows_key];
        console.log('>> meta rows: ', metaRows);
        return ({ metaRows, groupBy: this.props.groupBy ?? metaRows?.find(x => x.isGroup)?.columnName, error: '' });
    }

    async refineColumnsA(columns) {
        let changed = false;
        if (!(columns?.length > 0))
            return changed;

        if (this.props.modifyFields)
            if (Array.isArray(this.props.modifyFields)) {
                if (this.props.modifyFields?.length > 0)
                    for (let mf of this.props.modifyFields) {
                        let mfn = mf.name.toLowerCase()
                        let pf = columns.find(x => x.name.toLowerCase() === mfn);
                        if (pf) {
                            for (let key of Object.keys(mf))
                                pf[key] = mf[key];
                            changed = true;
                        }
                    }
            }
            else {
                Object.keys(this.props.modifyFields)?.forEach(k => {
                    let cf = columns.find(c => c.name.toLowerCase() === k.toLowerCase());
                    if (cf) {
                        for (let key of Object.keys(this.props.modifyFields[k]))
                            cf[key] = this.props.modifyFields[k][key];
                        changed = true;
                    }
                })
            }

        if (this.props.showFields?.length > 0)
            for (let col of columns) {
                col.visible = this.props.showFields.find(x => x.toLowerCase() === col.name?.toLowerCase()) ? true : false;
                if (!col.visible)
                    changed = true;
            }

        if (this.props.hideFields?.length > 0)
            for (let mf of this.props.hideFields) {
                let pf = columns.find(x => x.name.toLowerCase() === mf.toLowerCase());
                if (pf) {
                    pf.visible = false;
                    pf.isHidden = true;
                    changed = true;
                }
            }

        if (this.props.unhideFields?.length > 0)
            for (let mf of this.props.unhideFields) {
                let pf = columns.find(x => x.name.toLowerCase() === mf.toLowerCase());
                if (pf) {
                    pf.visible = true;
                    pf.isHidden = false;
                    changed = true;
                }
            }

        if (columns.find(x => x.order)) {
            columns = columns.sort((a, b) => (a.order ?? 9999) - (b.order ?? 9999));
            changed = true;
        }

        //console.log('>> ofields: ', ofields);

        for (let x of columns) { // converting lookup tables to array
            if (x.lookup?.length > 0 && typeof (x.Lookup) === 'string') {
                x.lookup = JSON.parse(x.lookup);
                changed = true;
            }
            else if (x.lookup?.table) {
                let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';
                let d = await apiPostA(`/api/${cont}/lookup/${x.lookup.table}`,
                    x.lookup?.field ? { [x.lookup.field]: x.lookup.equalTo ?? 'null' } : {});
                x.lookup = x.lookup?.refine ? d.filter(x.lookup.refine) : d;
                x.format = 1;
                changed = true;
            }
        }

        return changed;
    }

    async loadDataA() {
        let sk = {};
        if (this.props.selectedKeys?.length > 0) {
            this.props.selectedKeys.forEach(x => sk[x] = { checked: true });
            this.state.selectedKeys = sk; // } /*, () => console.log('selected ids: ', this.props.selectedKeys, ' items: ', sk)*/);
        }

        /*
        this.setState({ rows: crows, loading: false }, () => {
            //let forget = (this.props.sgf?.getForget) ? this.props.sgf.getForget() : this.props.forget;
            //console.log('............. grid loadData:froget=', forget, ' ', this.props.title);
            if (!(this.props.paState?.getForget?.()))
                this.setState({ ...(this.props.paState?.get?.()) }); //, () => console.log('......... grid remembered ', this.props.title, this.state)); //---------------------------------------------------------------------------------
 
            //if (this.props.initState && Object.keys(this.props.initState)?.length) {
            //    console.log('<- grid state << ', this.props.initState);
            //    this.setState({ rows: this.props.initState });
            //}
        });       
        */
        let crows = this.props.rows ?? this.props.dataSource ?? [];
        let ccolumns = this.props.columns ?? [];
        if (this.props.table?.length > 0 || this.props.url?.length > 0) {
            let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';
            let requestBody = null;

            if (this.props.fieldEqualities)
                requestBody = this.props.fieldEqualities;

            let url = requestBody ? `/api/${cont}/rows_fe/${this.props.table}`
                : this.props.url?.length > 0 ? this.props.url
                    : `/api/${cont}/rows/${this.props.table}` + (this.props.field?.length > 0 ? `?field=${this.props.field}&equalTo=${this.props.equalTo ?? 'null'}` : '');

            let rc = requestBody ? await apiPostA(url, requestBody) : await apiGetA(url);
            rc ??= { error: 'No response.', rows: [] };

            if (rc?.error?.length > 0)
                window.notif(rc.error);

            let rows = rc?._rows_key ? rc[rc._rows_key] : rc?.rows ?? rc ?? []; // rc.columns?.map(x => toLowerKeys(x, false, true));
            //console.log(rc?._rows_key ? rc.error : '');
            //console.log('+=+ rows=', rows);


            if (rows?.length > 0)
                crows.push(...rows);

            let columns = rc?._cols_key ? rc[rc._cols_key] : rc?.columns ?? [];
            if (columns?.length > 0)
                ccolumns.push(...columns);
            else {
                let f = [];
                try {
                    let el = await apiGetA(`/api/${cont}/cols/${this.props.table}`) ?? { error: 'No column data.' };
                    if (el?.error?.length > 0)
                        console.log(el.error);
                    else
                        f = el.list?.map(c => ({ ...c, caption: c.caption_FA ?? c.name, visible: c.isHidden !== true })) ?? [];
                } catch (ex) {
                    console.log(ex);
                }
                if (f./*gridCols?.*/length > 0) {
                    ccolumns.push(...f/*.gridCols*/);
                    if (!(this.state.parentFieldName?.length > 0))
                        this.state.parentFieldName = f/*.gridCols*/.find(x => x.isParent === true)?.name ?? '';
                }
            }
        }
        //console.log('+++ ', crows, cols);

        if (this.props.lowerCaseFields !== false)
            crows = toLowerKeys(crows);

        if (this.props.customRowFilter)
            crows = crows.filter(x => this.props.customRowFilter(x));

        if (this.props.customRowMap)
            crows = crows.map(x => this.props.customRowMap(x));

        if (this.props.sortBy)
            crows = crows.sort((a, b) => a[this.props.sortBy] > b[this.props.sortBy] ? 1 : a[this.props.sortBy] < b[this.props.sortBy] ? -1 : 0);

        if (!(ccolumns?.length > 0) && crows.length > 0 && crows[0])
            ccolumns = Object.keys(crows[0]).map(x => ({ name: x }));

        if (this.props.lowerCaseFields !== false)
            ccolumns = ccolumns.map(x => ({ ...x, name: x.name?.toLowerCase() ?? '?' }));

        await this.refineColumnsA(ccolumns);

        if (this.props.unhideFields?.includes('id')) {
            let idcol = ccolumns.find(x => x.name.toLowerCase() === 'id');
            if (!idcol) {
                idcol = { name: 'id', visible: true, caption: 'آیدی' };
                ccolumns = [idcol, ...ccolumns];
            }
            else
                idcol.visible = true;
        }

        if (this.props.asyncModifyData)
            await this.props.asyncModifyData(crows, ccolumns);

        //ccolumns.filter(x => x.foreignKey).forEach(col => {
        //})

        this.props.onDataLoaded?.({ rows: crows, columns: ccolumns, loading: false, error: '' });
        return ({ rows: crows, columns: ccolumns, loading: false, error: '' });

        // this.setState({ rows: crows, columns: ccolumns, loading: false }, () => {
        //     whenDone?.(crows, ccolumns);
        //     this.props.onDataLoaded?.(crows, ccolumns);
        // });
    }

    async saveStates() {
        if (this.state.dontSaveStates || !this.props.saveState)
            return;

        let data = { pageIndex: this.state.pageIndex }; // this.state; // 

        console.log('>>> saving states for ', this.sid, ' ', data);
        await localforage.setItem(this.sid, JSON.stringify(data));
    }

    async loadStatesA() {
        if (this.state.dontLoadStates || this.props.saveState !== true)
            return;

        //this.state.dontSaveStates = this.state.dontLoadStates = true;
        try {
            var s = await localforage.getItem(this.sid);

            var data = JSON.parse(s ?? '{}');

            console.log('>>> loading states for ', this.sid, ' ', data);

            // this.setState({ pageIndex: data.pageIndex }, () => {
            //     this.state.dontSaveStates = this.state.dontLoadStates = false;
            // });

            return data;
        }
        catch (ex) {
            console.log('Could not load state. ', ex);
        }

        return {};
        //this.state = { ...this.state, ...data }; //, dontLoadStates: false, dontSaveStates: false };

        //this.state.gridKey++;

        // this.forceUpdate(() => {
        //     this.state.dontSaveStates = this.state.dontLoadStates = false;
        // });
    }


    //--------------- columns

    // onExporting(e) {
    //     const workbook = new Workbook();
    //     const worksheet = workbook.addWorksheet('Main sheet');

    //     exportDataGrid({
    //         component: e.component,
    //         worksheet,
    //         autoFilterEnabled: true,
    //     }).then(() => {
    //         workbook.xlsx.writeBuffer().then((buffer) => {
    //             saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
    //         });
    //     });
    //     e.cancel = true;
    // }

    reloadRows = focusedId => {
        //this.loadDataA().then().catch(window.notif);
        this.setState({ rows: undefined, loading: true }, () => {
            this.loadDataA()
                .then(main => {
                    let { rows, error } = main ?? { error: 'No main response.' };
                    if (error?.length > 0) {
                        console.log('Could not load main info: ', error);
                        return;
                    }
                    this.state.rows = rows ?? [];
                    this.state.focusedRow = focusedId > 0 ? this.state.rows.find(x => x.id === focusedId) : undefined;
                })
                .catch(window.notif)
                .finally(() => this.setState({
                    gridKey: this.state.gridKey + 1,
                    loading: false
                }));
        });
    }

    autoUpdateOrInsertToTable(e, saveToTable) {
        if (!(saveToTable?.length > 0))
            return;

        let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';

        e.cancel = true;

        if (!(e.key > 0)) {
            //console.log('posting ', { TableName: e.table, ColumnName: e.column, ...e.newData });
            apiPostP(`/api/${cont}/addRow/uni.${saveToTable}`, { TableName: e.table, ColumnName: e.column, ...e.newData })
                .then(r => {
                    if (r.error?.length > 0) {
                        console.log('operation has error: ', r.error);
                        //e.cancel = true;
                        this.setState({ formMessage: r.error });
                    }
                    else
                        this.props.onSaved?.('insert', r.row);
                }).catch(window.notif);
        }
        else {
            let action = e.key > 0 ? apiPutP(`/api/${cont}/editRow/uni.${saveToTable}/${e.key}`, e.newData)
                : apiPostP(`/api/${cont}/addRow/uni.${saveToTable}`, { ...e.oldData, ...e.newData });

            action.then(r => {
                if (r.error?.length > 0) {
                    //e.cancel = true;
                    console.log('operation has error: ', r.error);
                    this.setState({ formMessage: r.error });
                }
                else
                    this.props.onSaved?.('update', r.row);
            }).catch(window.notif);
        }
    }

    onRowUpdating00(e) {
        console.log('update ', e.oldData, ' -> ', e.newData);

        let err = this.props.validationErrorForRow?.(e.newData);
        if (err?.length > 0) {
            e.cancel = true;
            console.log('operation has error: ', err);
            this.setState({ formMessage: err });
            return;
        }

        if (this.props.field?.length > 0)
            e.newData[this.props.field.toLowerCase()] = this.props.equalTo ?? null;

        this.props.doBeforeUpdate?.(e.newData, e.oldData);

        if (this.props.saveToTable?.length > 0) {
            e.table = e.oldData.tablename;
            e.column = e.oldData.columnname ?? e.oldData.name;
            this.autoUpdateOrInsertToTable(e, this.props.saveToTable);
            return;
        }

        let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';

        let url = this.props.updateUrl ?? this.props.table ?
            e.key > 0 ? `/api/${cont}/editRow/${this.props.table}/${e.key > 0 ? e.key : 0}` :
                `/api/${cont}/addRow/${this.props.table}` : '';

        if (!url) {
            if (!this.props.onManualUpdateRow) {
                console.log('warning: no updateUrl nor table to update row ', e);
                console.log('you can use [UniGrid props->] onManualUpdateRow={(id, newData, oldData, onError)=> {...}}');
                console.log('    or onManualUpdateRow={row=>new Promise(...)}');
            }
            else if (this.props.onManualUpdateRowP)
                this.props.onManualUpdateRowP(e.key, e.newData, e.oldData).then().catch(err => e.cancel = true);
            else
                this.props.onManualUpdateRow?.(e.key, e.newData, e.oldData, err => e.cancel = true);

            return;
        }

        e.cancel = !(e.key > 0);

        let callApi = r => {
            if (r.error?.length > 0) {
                //e.cancel = true;
                console.log('operation has error: ', r.error);
                this.setState({ formMessage: r.error }, () => this.props.onSavingFailed?.(r.error));
            }
            else {
                if (!(e.key > 0))
                    this.reloadRows();
                this.props.onSaved?.(e.key > 0 ? 'update' : 'insert', r.row);
            }
        }

        if (e.key > 0)
            apiPutP(url, e.newData).then(callApi).catch(window.notif);
        else
            this.grid.instance.refresh(true).then(() => apiPostP(url, { ...e.oldData, ...e.newData }).then(callApi).catch(window.notif));
    }

    onRowInserting(e) {
        console.log('inserting ', e);
        let err = this.props.validationErrorForNewRow?.(e.data);

        if (err?.length > 0) {
            e.cancel = true;
            console.log('operation has error: ', err);
            this.setState({ formMessage: err });
            return;
        }

        if (this.props.field?.length > 0)
            e.data[this.props.field] = this.props.equalTo ?? null;

        this.props.doBeforeInsert?.(e.data);

        if (this.props.saveToTable?.length > 0) {
            this.autoUpdateOrInsertToTable(e, this.props.saveToTable);
            return;
        }

        let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';
        let url = this.props.createUrl ?? this.props.table ? `/api/${cont}/addRow/${this.props.table}` : '';

        if (!url) {
            console.log('warning: no createUrl nor table to insert row ', e);
            console.log('you can use [UniGrid props->] onManualCreateRow= {(row, onError) => {...}}');
            console.log('    or onManualCreateRowP={row=>new Promise((resolve, reject) => { ... })}');

            if (this.props.onManualCreateRowP)
                this.props.onManualCreateRowP(e.data).then().catch(err => e.cancel = true);
            else
                this.props.onManualCreateRow?.(e.data, err => e.cancel = true);

            return;
        }

        e.cancel = true;
        this.grid.instance.refresh(true)
            .then(() => {
                apiPostP(url, e.data)
                    .then(r => {
                        let { row, error } = r ?? { error: 'No response.' };

                        if (error?.length > 0) {
                            console.log('operation has error: ', r.error);
                            this.setState({ formMessage: error }, () => this.props.onSavingFailed?.(error));
                        }
                        else {
                            console.log(e.data, ' row is saved => ', row);
                            this.reloadRows(row?.id);
                            this.props.onSaved?.(e.data?.id > 0 ? 'update' : 'insert', r.row);
                        }
                    }).catch(err => {
                        console.log('operation has error: ', err);
                        this.setState({ formMessage: err });
                    });
            })
            .catch(console.log);
    }

    onRowUpdating(e) {
        if (!(e.key > 0)) {
            e.data = { ...e.oldData, ...e.newData };
            this.onRowInserting(e);
            return;
        }

        console.log('update ', e.oldData, ' -> ', e.newData);

        let err = this.props.validationErrorForRow?.(e.newData);

        if (err?.length > 0) {
            e.cancel = true;
            console.log('operation has error: ', err);
            this.setState({ formMessage: err });
            return;
        }

        if (this.props.field?.length > 0)
            e.newData[this.props.field.toLowerCase()] = this.props.equalTo ?? null;

        this.props.doBeforeUpdate?.(e.newData, e.oldData);

        if (this.props.saveToTable?.length > 0) {
            e.table = e.oldData.tablename;
            e.column = e.oldData.columnname ?? e.oldData.name;
            this.autoUpdateOrInsertToTable(e, this.props.saveToTable);
            return;
        }

        let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';

        let url = this.props.updateUrl ?? this.props.table ? `/api/${cont}/editRow/${this.props.table}/${e.key}` : '';

        if (!url) {
            if (!this.props.onManualUpdateRow) {
                console.log('warning: no updateUrl nor table to update row ', e);
                console.log('you can use [UniGrid props->] onManualUpdateRow={(id, newData, oldData, onError)=> {...}}');
                console.log('    or onManualUpdateRow={row=>new Promise(...)}');
            }
            else if (this.props.onManualUpdateRowP)
                this.props.onManualUpdateRowP(e.key, e.newData, e.oldData).then().catch(err => e.cancel = true);
            else
                this.props.onManualUpdateRow?.(e.key, e.newData, e.oldData, err => e.cancel = true);

            return;
        }

        apiPutP(url, e.newData)
            .then(r => {
                if (r.error?.length > 0) {
                    //e.cancel = true;
                    console.log('operation has error: ', r.error);
                    this.setState({ formMessage: r.error }, () => this.props.onSavingFailed?.(r.error));
                }
                else
                    this.props.onSaved?.(e.key > 0 ? 'update' : 'insert', r.row);
            })
            .catch(window.notif);
    }

    onRowRemoving(e) {
        console.log('deleting ', e);
        let cont = this.props.dynaLoad === false ? 'uni' : 'dyna';

        let url = this.props.deleteUrl ?? this.props.table ? `/api/${cont}/deleteRow/${this.props.table}/${e.key}` : '';

        if (!url) {
            console.log('warning: no deleteUrl nor table to delete row ', e);
            console.log('you can use [UniGrid props->] onManualDeleteRow= id=>{...}');
            this.props.onManualDeleteRow?.(e.key);
            e.cancel = true;
            return;
        }

        apiDeleteP(`/api/${cont}/deleteRow/${this.props.table}/${e.key}`)
            .then(r => {
                let error = (r ?? { error: 'No response.' }).error ?? '';

                e.cancel = error?.length > 0;

                if (!e.cancel) {
                    this.props.onSaved?.('delete', e.key);
                    return;
                }

                window.notif('خطا در حذف رکورد: ' + error);

            }).catch(window.notif);
    }

    renderTitleBox = () => {
        return (
            <Inline spacing='0.5rem' //style={{ margin: '1rem 1rem 0 0', padding: '0' }}
            >
                {this.props.putItemsBeforeTitle}

                {this.props.favButton !== false && this.state.topMenuItem?.id > 0 &&
                    <ButtonComp key={'favbtn' + this.state.favKey + '_' + this.state.topMenuItem.isfavorite} width={35}
                        hint={this.state.topMenuItem.isfavorite ? 'حذف از برگزیده ها' : 'افزودن به برگزیده ها'}
                        onClick={() => Header.setFavoriteMenu(this.state.topMenuItem,
                            this.state.topMenuItem.isfavorite ? 'delete' : 'add',
                            () => {
                                this.state.favKey++;
                                this.forceUpdate();
                            }
                        )}
                    >
                        <FontAwesomeIcon key={`favicon${this.state.favKey}_${this.state.topMenuItem.isfavorite}`}
                            icon={this.state.topMenuItem.isfavorite ? 'bookmark' : 'star'}
                            beatFade={!this.state.topMenuItem.isfavorite}
                        />
                    </ButtonComp>
                }

                {this.props.noMetaGrid === false &&
                    <ButtonComp onClick={() => this.setState({
                        showUniSettings: !this.state.showUniSettings,
                        gridKey: this.state.gridKey + 1,
                    })}
                        hint='تنظیمات ستونها'
                    >
                        <FontAwesomeIcon icon={this.state.showUniSettings ? 'rectangle-list' : 'table-list'}
                            rotation={180}
                        />
                    </ButtonComp>
                }

                {this.state.topMenuItem?.id > 0 &&
                    <ButtonComp hint='انتساب جدول/کمپوننت به منو'
                        onClick={() => this.setState({ showAssigning: !this.state.showAssigning })}
                    >
                        <FontAwesomeIcon icon='ellipsis' />
                    </ButtonComp>
                }

                {this.state.topMenuItem?.id > 0 &&
                    <img src={`/images/menu/${this.state.topMenuItem.id}.png`} width={27} alt='' />
                }

                {(this.props.title || this.state.topMenuItem?.pagetitle) &&
                    <div style={{ fontWeight: '700', fontSize: this.props.titleFontSize ?? '1.3rem' }}>{this.state.topMenuItem?.pagetitle ?? this.props.title}</div>
                }
                {this.state.groupBy?.length > 0 && this.props.noGroupButtons !== true &&
                    <>
                        <ButtonComp /*icon='expand'*/ hint='باز کردن گروهها' /* text='تنظیمات ستونها'*/
                            onClick={() => this.setState({ autoExpandAll: true })}
                        >
                            <FontAwesomeIcon icon='circle-chevron-down' />
                        </ButtonComp>
                        <ButtonComp /*icon='collapse'*/ hint='فشرده کردن گروهها' /* text='تنظیمات ستونها'*/
                            onClick={() => this.setState({ autoExpandAll: false })}
                        >
                            <FontAwesomeIcon icon='circle-chevron-up' />
                        </ButtonComp>
                    </>
                }
                {this.props.putItemsAfterTitle}
            </Inline>
        );
    };

    // putItemOnToolbarBefore = item => {
    //     if (!item)// && !this.props.putTitleBoxInToolbar)// && !(this.props.title?.length > 0))
    //         return;

    //     let me = document.querySelector("#uniGridContainer_" + this.sid + " > div > div.dx-"
    //         + (this.isTreeList ? 'treelist' : 'datagrid') + "-header-panel > div > div > div.dx-toolbar-before");

    //     if (!me)
    //         return;

    //     //let titleOnToolbarElement = `<div style='display:flex;align-items:center;height:100%;font-weight:700;padding:0 1rem;' class='${this.props.titleOnToolbar_className ?? ''}'>${this.props.titleOnToolbar}</div>`;
    //     //me.innerHTML = renderToPipeableStream(titleOnToolbarElement);

    //     let cmp = (
    //         <div style={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             height: '100%',
    //             fontWeight: '700',
    //             padding: '0 1rem',
    //         }} className={this.props.toolbarItemsNear_className ?? ''}
    //         >
    //             {/* {this.props.table?.length > 0 && this.props.noMetaGrid !== true && window.user?.isadmin === true &&
    //                 <span style={{ marginLeft: '5px' }}>
    //                     <Button icon='detailslayout' hint='تنظیمات ستونها' // text='تنظیمات ستونها'
    //                         onClick={() => this.setState({ showUniSettings: !this.state.showUniSettings })}
    //                     />
    //                 </span>
    //             } */}
    //             {/* {this.props.title?.length > 0 &&
    //                 <span className='unigrid-title'>{this.props.title}</span>
    //             } */}

    //             {/* {this.props.putTitleBoxInToolbar && this.renderTitleBox()} */}

    //             {item ?? ''}
    //         </div>
    //     );

    //     ReactDOM.createRoot(me)?.render?.(cmp, me);
    // }

    // renderCustomComponent = (frm, col) => {
    //     console.log('frm: ', frm);
    //     let { component: form } = frm;
    //     let name = frm.dataField;
    //     const currentValue = form.option('formData')[name];

    //     // console.log('cr:', cr);
    //     console.log('form option:', form.option());
    //     console.log('formData:', frm.formData);
    //     // console.log('col:', col);

    //     if (col.component === 'TarikhPicker') {
    //         return (
    //             <TarikhPicker {...col.componentProps}
    //                 value={currentValue} // form.option(`formData.${name}`)}
    //                 onValueChanged={v => {
    //                     //console.log('on tarikh changed: ', v);
    //                     // form.option(`formData.${name}`, v);
    //                     //form.updateData(name, v);
    //                     //form.option('formData.onFieldDataChanged')(name, v);
    //                     //console.log(form.option('formData'));

    //                     // const newFormData = { ...form.option('formData') };
    //                     // newFormData[name] = v;
    //                     // form.option('formData', newFormData);

    //                     form.updateData?.(name, v);

    //                     //const grid = form.option("integrationOptions").dxWidgetComponent;
    //                     // const grid = form.option("integrationOptions")?.dxWidgetComponent;
    //                     // if (grid) {
    //                     //     const rowKey = frm.formData[grid.option("keyExpr")];
    //                     //     grid.getController("editing").updateFieldValue(rowKey, name, v);
    //                     // }

    //                     const onFieldDataChanged = form.option("onFieldDataChanged");
    //                     if (typeof onFieldDataChanged === "function") {
    //                         onFieldDataChanged({ dataField: name, value: v });
    //                     }
    //                 }
    //                 }
    //             />
    //         );
    //     }

    //     // if (col.component === 'TarikhTimePicker')
    //     //     return (<TarikhTimePicker {...col.componentProps} />);

    //     return (<label>Unknown component: {col.component}</label>);
    // }

    renderCustomComponent = (cc, x) => {
        if (this.props.renderCustomComponents?.[x.component])
            return this.props.renderCustomComponents[x.component](cc, x);

        if (x.component === 'SelectBox' || x.lookup?.length > 0)
            return (
                <SelectBox {...x.componentProps} dataSource={x.lookup} ////////////////////////////////////////
                    value={cc.value} onValueChanged={e => cc.setValue(e.value)}
                />
            );

        if (x.component === 'CheckBox')
            return (
                <CheckBox {...x.componentProps}
                    value={cc.value} onValueChanged={e => cc.setValue(e.value)}
                />
            );

        if (x.component === 'CarPlate')
            return (
                <CarPlate {...x.componentProps}
                    value={cc.value} onValueChanged={cc.setValue}
                />
            );
        if (x.component === 'TarikhPicker')
            return (
                <TarikhPicker {...x.componentProps}
                    value={cc.value} onValueChanged={cc.setValue}
                />
            );

        if (x.component === 'TarikhTimePicker')
            return (
                <TarikhTimePicker {...x.componentProps}
                    value={cc.value} onValueChanged={cc.setValue}
                />
            );

        if (x.component === 'TimePickerHHMM')
            return (
                <TimePickerHHMM {...x.componentProps}
                    value={cc.value} onValueChanged={cc.setValue}
                />
            );

        return (<label>Unknown component: {x.component}</label>);
    }

    renderGroupCell = (cell, col) => (
        this.props.groupCellRender?.(cell, col) ??
        <div style={{ display: 'inline-flex', alignItems: 'center', ...this.props.groupCellStyle }}>
            {this.props.groupCellItemsBefore && <span>{this.props.groupCellItemsBefore?.(cell, col)}</span>}
            <span style={{ fontWeight: '700' }}>{col.caption}: {cell.displayValue/*cell.value*/}</span>
            {this.props.groupCellItemsAfter && <span>{this.props.groupCellItemsAfter?.(cell, col)}</span>}
        </div>
    );

    componentDidMount() {
        //console.log('>> UniGrid is mounted.');
        Promise.all([
            this.loadMetaDataA(),
            this.loadDataA(),
            this.loadStatesA()
        ]).then(res => {
            let [meta, main, data] = res ?? [];
            let { metaRows, groupBy, error: error1 } = meta ?? { error: 'No meta response.' };
            if (error1?.length > 0)
                console.log('Could not load meta info: ', error1);
            else {
                this.state.metaRows = metaRows ?? [];
                this.state.groupBy = groupBy ?? '';
            }

            let { rows, columns, error: error2 } = main ?? { error: 'No main response.' };
            if (error2?.length > 0)
                console.log('Could not load main info: ', error2);
            else {
                this.state.rows = rows ?? [];
                let mcols = metaRows?.map(c => ({
                    name: c.name.toLowerCase(),
                    readonly: c.isReadonly,
                    caption: c.caption_FA ?? c.caption_EN
                })) ?? [];
                this.state.columns = (columns ?? []).map(c => ({ ...c, ...mcols.find(x => x.name === c.name) }));
                this.cascadedLookups = this.state.columns.filter(c => c.lookupFunc) ?? [];
                this.cascadedLookups.forEach(col => {
                    col.lookup = col.lookupFunc(col, this.state);
                });
                //console.log('columns: ', this.state.columns); 
            }

            this.state.data = data;
        }).catch(console.log)
            .finally(() => this.setState({ loading: false }, () => this.props.onDataLoaded?.(this.state.rows, this.state.columns)));

        //     .catch(err => console.log('Could not get states by localForage items, ', err))

    }

    componentWillUnmount() {
        //console.log('>> UniGrid is unmounted.');
        // if (!this.state.dontSaveStates)
        //     this.saveStates();
    }

    componentDidUpdate() {
        if (this.cascadedLookups?.length > 0)
            this.cascadedLookups.forEach(col => {
                col.lookup = col.lookupFunc(col, this.state);
            });
    }

    render() {
        if (!this.props.ignoreUserCheck && !(window.user?.id > 0))
            return (
                <div id={this.props.id ?? this.sid + '_wrapper'}
                    className='unigrid-wrapper'
                    style={{
                        width: this.props.width > 0 ? this.props.width + 'px' : (this.props.width ?? 'auto'),
                        height: this.props.height > 0 ? this.props.height + 'px' : (this.props.height ?? 'auto'),
                        ...this.props.wrapperStyle
                    }}
                >
                    {invalidUser_component}
                </div>
            );

        if (this.state.loading)
            return (
                <>
                    <div className='unigrid-wrapper'
                        style={{ ...this.props.wrapperStyle, padding: '1rem',/*, position: 'relative'*/ }}>
                        {this.renderTitleBox()}

                        {this.state.showAssigning && this.state.topMenuItem?.id > 0 &&
                            <div style={{
                                padding: '1rem',
                                //display: this.state.topMenuItem?.id > 0 && this.state.showAssigning ? 'block' : 'none'
                            }}>
                                <PageAssigner menuItem={this.state.topMenuItem} textBoxWidth='50rem'
                                    onSaved={this.forceUpdate}
                                    onClose={() => this.setState({ showAssigning: false })}
                                />
                            </div>
                        }
                    </div>

                    <div className='unigrid-wrapper'
                        style={{
                            //position: 'absolute',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            //top: '0px',
                            //left: '0px',
                            width: this.props.width > 0 ? this.props.width + 'px' : (this.props.width ?? 'inherit'),
                            height: this.props.height > 0 ? this.props.height + 'px' : (this.props.height ?? 'inherit'),
                            //...this.props.wrapperStyle
                            //zIndex: '900'
                        }}
                    >
                        <Spinner />
                    </div>
                </>
            );

        // Runtime validation for imported UI components (helps detect CJS/ESM interop issues)
        try {
            // Diagnostic validation removed — assuming imports are correct.
        } catch (ex) {
            console.error('UniGrid component validation failed', ex);
        }

        let columnsInfo = (this.state.columns ?? Object.keys(this.state.rows?.[0] ?? [{ name: 'name' }])?.map(x => ({ name: x })))
            ?.filter(x => !x.name?.startsWith('pa_') && !x.name?.startsWith('__')
                //&& !x.name?.toLowerCase()?.endsWith('date') ///////////////////////////
                //&& x.visible != false //////////////////////////////////
            );

        columnsInfo.forEach(x => { //////////////////////////
            x.visible = x.visible !== false && x.isHidden !== true;
            x.colSpan = x.columnWidth;
            if (x.lookupFunc)
                x.lookup = x.lookupFunc(x, this.state);
        });

        if (this.props.hideFields?.length > 0)
            columnsInfo.forEach(x => { //////////////////////////
                x.visible = x.visible !== false && this.props.hideFields.findIndex(h => h.toLowerCase() === x.name.toLowerCase()) < 0;
            });

        // let colCount = 0;
        // columnsInfo.forEach(x => {
        //     if (x.visible)
        //         colCount += (x.colSpan > 0 ? colSpan : 1);
        // });
        // colCount ??= 1;


        let parentFieldName = this.state.parentFieldName;
        this.isTreeList = parentFieldName?.length > 0 && this.state.forceUseGrid !== true;
        let firstVisibleColumnInfo = columnsInfo?.find(c => c.visible !== false);

        let columns = columnsInfo?.map(x => {
            x.format ??= x.dataTypeFormat;

            if (x.lookupJsn?.length > 1)
                x.lookup = JSON.parse(x.lookupJsn);

            let visibleAtGrid = x.visible !== false && x.isHidden !== true && x.isHiddenAtGrid !== true && x.visible !== 'form';

            return (
                <Column key={x.name} name={x.name} dataField={x.name} caption={x.caption ?? x.name}
                    visible={visibleAtGrid} //{x.visible}
                    allowEditing={x.readOnly !== true && x.readonly !== true} colSpan={x.colSpan ?? 0}
                    //fixed={this.isTreeList && x.name === firstVisibleColumnInfo?.name}
                    lookup={defLookupDataSource(x.lookup)} //calculateDisplayValue={c => ...} calculateCellValue=...
                    dataType={x.format === 'bit' || x.format === 'bool' || x.format === 2 ? 'boolean'
                        : x.format === 'number' ? 'number' : x.format == 'currency' ? 'currency' : undefined}
                    grouped={this.state.groupBy?.toLowerCase() === x.name?.toLowerCase()}

                    width={x.width ??
                        (this.props.customCellWidth && Object.keys(this.props.customCellWidth)?.includes?.(x.name)
                            ? this.props.customCellWidth[x.name] : this.undefined
                        )}

                    format={x.dataType == 'currency' ? ',##0' : undefined}
                    //format={x.dataType == 'currency' ? { precision: 0, useCurrencyAccountingStyle: true } : undefined}

                    //width={this.props.width * x.colSpan / colCount}
                    editCellComponent={
                        x.component === 'NumberBox' || x.format === 'number' || x.format == 'currency' ? NumberBox :
                            x.component === 'SelectBox' && x.format === 'boolean' ? SelectBox :
                                x.component === 'CheckBox' || x.format === 'boolean' ? CheckBox :
                                    x.component === 'CarPlate' || x.format === 'carplate' ? CarPlate :
                                        x.component === 'TarikhPicker' || x.format === 'tarikh' || x.format === 3 || x.name.startsWith('tarikh') /*|| x.name?.toLowerCase()?.endsWith('per')*/ ? TarikhPicker
                                            : x.component === 'TarikhTimePicker' || x.format === 'tarikhtime' ? TarikhTimePicker
                                                : x.component === 'TimePicker' || x.format === 'time' ? TimePickerHHMM : undefined
                    }

                    editCellRender={!x.component ? undefined : cc => this.renderCustomComponent(cc, x)}
                    cellRender={!visibleAtGrid ? undefined :
                        x.cellRender ? e => x.cellRender(e, /*isFocused=*/ this.state.focusedRow?.id === e.data?.id) :
                            this.props.customCellRender && Object.keys(this.props.customCellRender)?.includes?.(x.name)
                                ? this.props.customCellRender[x.name]
                                //   : (x.readOnly || x.readonly || this.props.readOnly || this.props.readonly) && x.dataType == 'currency' ? ci => (<span style={{ color: 'red' }}>{formatNumber(ci.value ?? 0)}</span>)
                                : undefined
                    }
                    // groupCellRender={cell => (
                    //     this.props.groupCellRender?.(cell, x) ??
                    //     <div style={{ display: 'inline-flex', alignItems: 'center', ...this.props.groupCellStyle }}>
                    //         {this.props.groupCellItemsBefore && <span>{this.props.groupCellItemsBefore?.(cell, x)}</span>}
                    //         <span style={{ fontWeight: '700' }}>{x.caption}: {cell.value}</span>
                    //         {this.props.groupCellItemsAfter && <span>{this.props.groupCellItemsAfter?.(cell, x)}</span>}
                    //     </div>
                    // )}

                    groupCellRender={cell => this.renderGroupCell(cell, x)}
                    {...x.dxProps}
                />
            );
        });

        if (!(columns?.length > 0))
            return <div style={{ opacity: '0.5', margin: '1rem' }}>اطلاعات در دسترس نیست</div>;

        const key = this.props.keyExpr ?? this.state.columns?.find(x => x.name === 'id') ? 'id' : this.state.columns?.find(x => x.name === 'key') ? 'key' : 'id'; // this.state.columns?.[0]?.name;
        let formColCount = this.props.formColCount
            ?? (isMobile ? 1
                : columns.length > 15 ? 4
                    : columns.length > 10 ? 3
                        : 2); // Math.floor(Math.sqrt(2 + (columns?.length ?? 0)));
        let formWidth = isMobile ? '90vw' : this.props.formWidth ?? `${formColCount * 20}%`;

        let generalProps = {};
        let programmedProps = {
            key: `${this.props.key ?? ''}_grid${this.state.gridKey}_${this.state.rows?.length ?? 0}_${this.props.table ?? ''}_${this.props.url ?? ''}`,
            dataSource: this.state.rows,
            rtlEnabled: !this.props.ltr,
            keyExpr: key,
            headerFilter: true,
            showBorders: this.props.showBorders !== false,
            allowUpdating: this.props.allowDeleting !== false && this.props.readOnly !== true,
            allowAdding: this.props.allowAdding !== false && this.props.readOnly !== true,
            allowDeleting: this.props.allowDeleting !== false && this.props.readOnly !== true,
            columnAutoWidth: this.props.columnAutoWidth !== false,
            onSelectedRowKeysChange: s => {
                this.selectedKeys = s;
                this.props.onSelectedKeysChanged?.(s);
            },
            showColumnLines: true,
            showRowLines: true,
            hoverStateEnabled: true,
            onSaving: e => this.props.onSaving?.(e),
            onSaved: e => this.props.onSaved?.(e),
            onRowRemoving: this.onRowRemoving,
            onRowUpdating: e => this.onRowUpdating(e),
            onRowInserting: e => this.onRowInserting(e),
            onRowInserted: e => this.onRowInserted(e),

            // onSelectionChanged={e => {
            //     console.log('=======================');
            //     if (this.props.allowChangeSelection === false && this.grid)
            //         this.grid.set = this.state.selectedKeys;
            // }}
            maxHeight: window.innerHeight * 0.9, //??
            //onRowInserted={e => console.log('inseted: ', e)}                      
            // onEditorPrepared={e => {
            //     console.log('editor prepared: ', e);
            //     if (this.props.table?.length > 0)
            //         return;
            //     e.lookup = false;
            //     e.dataField = e.name;
            //     e.dataType = 'string';
            // }}
            focusedRowKey: this.state.focusedRow?.id ?? this.props.focusedRowKey,
            focusedRowEnabled: this.props.focusedRowEnabled !== false,

            onFocusedRowChanged: e => {
                if (this.state.focusedRowEnabled == false)
                    return;
                this.state.focusedRow = e.row?.data;
                this.state.contextMenuItems?.forEach(x => x.visible = this.props.contextMenuItemVisibleIf?.(x, e.row?.data) ?? true);
                this.props.onFocusedRowChanged?.(e.row?.data);
                //if (!this.props.onFocusedRowChanged)
                this.forceUpdate();
                //     // if (!(e.row?.data))
                //     //     return;

                //     this.state.contextMenuItems?.forEach(x => x.visible = this.props.contextMenuItemVisibleIf?.(x, e.row?.data) ?? true);
                //     this.setState({ focusedRow: e.row?.data }, () => this.props.onFocusedRowChanged?.(e.row?.data));
                //     //this.props.onFocusedRowChanged?.(e.row?.data);
                //     //this.forceUpdate();
                //     //console.log('-> focused row: ', e.row?.data);
                //     //this.setState({ focusedRow: e.row.data });
            }
        }
        let programmedPropsKeys = Object.keys(programmedProps);

        Object.keys(this.props).filter(x => x !== 'id' && x !== 'columns' && x !== 'rows'/* && x !== 'customColumns'*/
            && !programmedPropsKeys.includes(x))
            .forEach(x => generalProps[x] = this.props[x]);

        let btnCellStyle = {
            fontSize: '18px',
            textAlign: 'center', width: '100%', height: '100%',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            cursor: 'pointer',
        };

        let firstVisibleColumn = columns.find(c => c.key === firstVisibleColumnInfo?.name);

        let editingForm_ExtraItems = this.props.editingForm_ExtraItems?.length > 0 ? this.props.editingForm_ExtraItems :
            this.props.editingForm_ExtraItems ? [this.props.editingForm_ExtraItems] : [];

        return (
            <div id={this.props.id ?? this.sid + '_wrapper'} className='unigrid-wrapper' key={'outerDiv' + this.state.outerDivKey}
                style={{ ...this.props.wrapperStyle/*, position: 'relative'*/ }}>

                {(this.props.putTitleBoxInToolbar === false || this.props.noToolbar === true) && this.renderTitleBox()}

                {this.state.showAssigning && this.state.topMenuItem?.id > 0 &&
                    <div style={{
                        padding: '1rem',
                        //display: this.state.topMenuItem?.id > 0 && this.state.showAssigning ? 'block' : 'none'
                    }}>
                        <PageAssigner menuItem={this.state.topMenuItem} textBoxWidth='50rem'
                            onSaved={this.forceUpdate}
                            onClose={() => this.setState({ showAssigning: false })}
                        />
                    </div>
                }


                {((this.props.table?.length > 0 || this.props.sid?.length > 0) && this.props.noMetaGrid === false) && // || this.props.title?.length > 0) &&
                    <div style={{ paddingBottom: '5px' /*position: 'relative', top: '40px', right: '5px', zIndex: '2'*/ }}>
                        {(this.props.table?.length > 0 || this.props.sid?.length > 0) && this.props.noMetaGrid === false && window.user?.isadmin === true &&
                            <span style={{ marginLeft: '5px' }}>
                                {/* {this.props.hideMetaGridButton !== true &&
                                    <ButtonComp icon='detailslayout' hint='تنظیمات ستونها' 
                                        onClick={() => this.setState({ showUniSettings: !this.state.showUniSettings })}
                                    />
                                } */}
                                {/* {this.state.groupBy?.length > 0 &&
                                    <ButtonComp icon='expand' hint='باز کردن گروهها' 
                                        onClick={() => this.setState({ autoExpandAll: true })}
                                    />
                                }
                                {this.state.groupBy?.length > 0 &&
                                    <ButtonComp icon='collapse' hint='فشرده کردن گروهها' 
                                        onClick={() => this.setState({ autoExpandAll: false })}
                                    />
                                } */}
                                {this.state.showUniSettings &&
                                    <UniMetaGrid key={this.state.showUniSettings + 'ugs'} dynaLoad={this.state.dynaLoad}
                                        title={this.props.title ?? this.state.topMenuItem?.pagetitle}
                                        sourceTable={this.props.table} sourceSid={this.props.url?.length > 0 ? this.props.sid : ''}
                                        sourceColNames={this.props.url?.length > 0 ? this.state.columns?.map(x => x.name) : []}
                                        onSaved={e => {
                                            this.state.rows = undefined;
                                            this.state.columns = undefined;
                                            this.loadDataA().then(() => this.setState({ gridKey: this.state.gridKey + 1 }));
                                        }}

                                        onCloseMe={() => this.setState({ showUniSettings: false })}
                                    />}
                            </span>
                        }
                        {/* {false && this.props.title?.length > 0 && <span className='unigrid-title'>{this.props.title}</span>} */}
                    </div>
                }

                {this.isTreeList ?
                    <TreeListComp id={"uniGridContainer_" + this.sid} ref={el => this.grid = el}
                        autoExpandAll={false} //expandedRowKeys={['Company_Parts__']}
                        {...programmedProps}
                        //onSaved={r =>this.forceUpdate()}
                        {...generalProps}
                        onContentReady={e => {
                            //this.putItemOnToolbarBefore(this.props.toolbarItemsNear);
                            this.state.loading = false;
                            this.props.onContentReady?.(e);
                        }}
                    >
                        {this.props.multiSelect && this.props.allowChangeSelection !== false && <Selection mode='multiple' recursive={true} showCheckBoxesMode='always' />}
                        {false && <Selection mode="single" />}
                        {(this.props.paging !== false || this.props.pageSize > 0) &&
                            <Paging defaultPageSize={this.props.pageSize ?? 15}
                                //pageIndex={this.state.pageIndex}
                                onPageIndexChange={_ => this.setState({ /*pageIndex,*/ focusedRow: {} }, this.saveStates)}
                            />
                        }
                        <SearchPanel visible={this.props.noToolbar !== true} placeholder={'جستجو'} searchVisibleColumnsOnly />
                        <HeaderFilter visible={this.props.headerFilter !== false} />
                        {this.props.filterPanel &&
                            <TFilterPanel visible={this.props.filterPanel !== false}
                                texts={{
                                    clearFilter: 'حذف فیلتر',
                                    createFilter: 'ایجاد فیلتر',
                                    filterEnabledHint: 'فیلتر فعال است'
                                }}
                            />
                        }
                        <Scrolling mode='standard' />
                        <FilterRow visible={this.props.filterRow !== false} showOperationChooser={false} />
                        <FilterBuilderPopup />
                        <Export enabled={true} formats={['pdf', 'word', 'excel']} allowExportSelectedData={true} />
                        <Sorting mode='single' ascendingText='مرتب سازی صعودی' descendingText='مرتب سازی نزولی' clearText='حذف مرتب سازی' />
                        <TStateStoring enabled={false && this.props.saveState} type='localStorage' storageKey={this.sid} />
                        {this.props.allowEditing !== false &&
                            <Editing
                                mode={this.props.editingMode ?? 'popup'}
                                allowUpdating={this.props.allowUpdating !== false && this.props.readOnly !== true}
                                allowAdding={this.props.allowAdding !== false && this.props.readOnly !== true}
                                allowDeleting={this.props.allowDeleting !== false && this.props.readOnly !== true}
                                useIcons={true}
                                onEditRowKeyChange={k => {
                                    let g = this.grid.instance;
                                    //console.log(k, typeof (k))

                                    if (k === null && g.pastSelectedIndex >= 0) {
                                        g.option("focusedRowIndex", g.pastSelectedIndex);
                                    }
                                    else if (k !== null && !(k > 0)) {
                                        g.pastSelectedIndex = g.option("focusedRowIndex");
                                        g.option("focusedRowIndex", -1);
                                    }
                                }}
                            >
                                <Popup title={"ورود اطلاعات " + (this.props.title ?? '')} showTitle={true}
                                    width={formWidth} height={this.props.popupHeight ?? 'fit-content'}
                                    resizeEnabled={true} shading={true} shadingColor='rgba(0,0,0,0.5)'
                                    onHiding={this.props.onEditPopupHiding}
                                    onShowing={this.props.onEditPopupShowing ?? (() => this.state.formMessage = '')}
                                    onShown={e => {
                                        //console.log(this.grid.instance.editingRowKey);
                                        this.props.onEditPopupShown?.(e, this.grid.instance.editingRowKey);
                                    }}
                                    onHidden={e => {
                                        let g = this.grid.instance;
                                        if (g.pastSelectedIndex >= 0) {
                                            g.option("focusedRowIndex", g.pastSelectedIndex);
                                        }
                                        this.props.onEditPopupHidden?.(e);
                                    }}
                                />

                                <Form ref={el => this.form = el} key={this.state.formMessage} colCount={formColCount}
                                    id={this.props.title + 'form'}  {...this.props.editFormProps}
                                >
                                    {this.props.renderForm ? this.props.renderForm(this.state, this.grid)
                                        : columnsInfo?.filter(x => x.name !== '_sequence' && x.visible !== false && x.visible !== 'grid' && x.isHiddenAtForm != true)
                                            ?.map(x =>
                                                <Form_Item name={x.name} dataField={x.name} key={x.name} isRequired={x.required === true}
                                                    lookup={defLookupDataSource(x.lookup)}
                                                    label={{ text: x.caption ?? x.name }}
                                                    colSpan={x.colSpan > 0 && x.colSpan <= formColCount ? x.colSpan : 1}
                                                    cssClass={x.rtl !== false && x.ltr !== true ? 'mdh-right-align' : 'mdh-left-align'}
                                                    rtlEnabled={x.rtl !== false && x.ltr !== true}
                                                    editorOptions={{
                                                        //format: x.format == 'currency' ? { precision: 0, useCurrencyAccountingStyle: true } : undefined,
                                                        readOnly: x.readOnly === true || x.readonly === true,
                                                        rtlEnabled: x.rtl !== false && x.ltr !== true,
                                                        editCellComponent: x.format === 'tarikh' || x.format === 3 || x.component === 'TarikhPicker' ? TarikhPicker : undefined
                                                    }}
                                                />
                                            )
                                    }
                                    {
                                        ...editingForm_ExtraItems
                                    }

                                    {this.state.formMessage?.length > 0 &&
                                        <SimpleItem colSpan={2}>
                                            <div style={{ color: 'red', background: 'yellow' }}>
                                                {this.state.formMessage}
                                            </div>
                                        </SimpleItem>
                                    }
                                </Form>
                                {/* <Form ref={el => this.form = el} key={this.state.formMessage} colCount={formColCount}>
                                {columnsInfo.map(x =>
                                    x.lookup?.length > 0 ?
                                        <Item dataField={x.name} colSpan={x.colSpan > 0 ? x.colSpan : 1}
                                            editorOptions={{ readOnly: x.readOnly === true || x.readonly === true }}>
                                        </Item>
                                        :
                                        <Item dataField={x.name} colSpan={x.colSpan > 0 ? x.colSpan : 1}
                                            editorOptions={{ readOnly: x.readOnly === true || x.readonly === true }}
                                        />)

                                    //dataField="Notes"
                                    //editorType="dxTextArea"
                                    //colSpan={2}
                                    //editorOptions={notesEditorOptions}
                                }

                                {this.state.formMessage?.length > 0 &&
                                    <SimpleItem colSpan={2}>
                                        <div style={{ color: 'red', background: 'yellow' }}>
                                            {this.state.formMessage}
                                        </div>
                                    </SimpleItem>}
                            </Form> */}
                            </Editing>
                        }
                        {this.props.allowChangeSelection === false && this.props.multiSelect &&
                            <Column caption='' calculateDisplayValue={row => this.props.selectedKeys?.includes(row.id) ? '✓' : ''}
                                width='4rem' alignment='left'
                            />
                        }
                        {this.props.noToolbar !== true &&
                            <TToolbar>
                                {this.props.putTitleBoxInToolbar !== false &&
                                    <TToolbarItem location='before' render={this.renderTitleBox}
                                    />
                                }
                                {this.props.addToToolbar &&
                                    [...(this.props.addToToolbar?.length > 1 ? this.props.addToToolbar : [this.props.addToToolbar])
                                        .map(x => <TToolbarItem>{x}</TToolbarItem>)]
                                }

                                <TToolbarItem location='after'
                                    render={() => {
                                        return (
                                            <div style={{ marginLeft: '5px', height: '100%' }}>
                                                <ButtonComp onClick={e => this.setState({ forceUseGrid: true })}
                                                    hint='نمایش جدولی' height='100%'
                                                >
                                                    <FontAwesomeIcon icon='list' fontSize='1rem' rotation={180} />
                                                </ButtonComp>
                                            </div>
                                        );
                                    }}
                                />

                                {this.props.allowAdding !== false && this.props.readOnly !== true && <GToolbarItem name='addRowButton' />}
                                <TToolbarItem name='exportButton' />
                                <TToolbarItem name='revertButton' />
                                <TToolbarItem name='searchPanel' />
                            </TToolbar>
                        }

                        {/*e.component.columnOption("command:edit", "visibleIndex", -1)  */}

                        {this.props.readOnly !== true &&
                            <Column type="buttons" width='5rem'>
                                <ButtonComp name="edit" />
                                <ButtonComp name="delete" />
                            </Column>
                        }
                        {firstVisibleColumn}

                        {this.props.buttonColumns && this.props.buttonColumns.filter(x => x.locateAtBefore)?.map(b =>
                            <Column key={b.name} caption={b.caption} width={b.width ?? '3rem'} //'fit-content'} //columnAutoWidth={false}
                                cellRender={c => (
                                    b.useButton ?
                                        <ButtonComp width={b.width ?? '100%'} rowData={c.data}
                                            icon={b.iconOfRow?.(c.data) ?? b.icon} text={b.textOfRow?.(c.data) ?? b.text}
                                            disabled={b.disableIfRow?.(c.data) === true}
                                            {...b.props} className='ka-no-padding' style={this.props.buttonStyle}
                                            onClick={e => b.onClick?.(c.data)}
                                        /> // onClick={e => b.onClick?.(e.component._props.rowData)}
                                        :
                                        <i className={'dx-icon-' + (b.iconOfRow?.(c.data) ?? b.icon) + ' ka-no-padding'}
                                            style={btnCellStyle} onClick={e => b.onClick?.(c.data)}
                                        >{b.textOfRow?.(c.data) ?? b.text}
                                        </i>)
                                }>
                            </Column>)
                        }

                        {columns.filter(x => x.key !== firstVisibleColumn?.key && x.visible !== false && x.visible !== 'form')}

                        {this.props.customColumns?.map(cc =>
                            <Column key={cc.name} caption={cc.caption} width={cc.width ?? 'fit-content'}
                                cellRender={cc.cellRender}
                                {...cc.dxProps}
                            />)
                        }

                        {this.props.buttonColumns && this.props.buttonColumns.filter(x => !x.locateAtBefore)?.map(b =>
                            <Column key={b.name} caption={b.caption} width={b.width ?? '3rem'} //'fit-content'} //columnAutoWidth={false}
                                cellRender={c => (
                                    b.useButton ?
                                        <ButtonComp width={b.width ?? '100%'} rowData={c.data}
                                            icon={b.iconOfRow?.(c.data) ?? b.icon} text={b.textOfRow?.(c.data) ?? b.text}
                                            disabled={b.disableIfRow?.(c.data) === true}
                                            {...b.props} className='ka-no-padding' style={this.props.buttonStyle}
                                            onClick={e => b.onClick?.(c.data)}
                                        /> // onClick={e => b.onClick?.(e.component._props.rowData)}
                                        :
                                        <i className={'dx-icon-' + (b.iconOfRow?.(c.data) ?? b.icon) + ' ka-no-padding'}
                                            style={btnCellStyle} onClick={e => b.onClick?.(c.data)}
                                        >{b.textOfRow?.(c.data) ?? b.text}
                                        </i>
                                )}
                            >
                            </Column>
                        )}
                        {/* 
                        {this.props.readOnly !== true &&
                            <Column type="buttons" width='5rem'>
                                <Button name="edit" />
                                <Button name="delete" />
                            </Column>
                        } */}
                    </TreeListComp>
                    : //=======================================================================================================
                    <DataGridComp id={this.props.id ?? "uniGridContainer_" + this.sid}
                        ref={el => this.grid = el}
                        {...programmedProps}
                        {...generalProps}
                        onContentReady={e => {
                            //this.putItemOnToolbarBefore(this.props.toolbarItemsNear);
                            this.state.loading = false;
                            this.props.onContentReady?.(e);

                            //this.setState({ gridKey: this.state.gridKey + 1, loading: false })
                        }}
                        export={{ enabled: true, formats: ['pdf', 'xlsx'] }}
                        onExporting={e => {
                            onExporting(e, this.props.export?.fileName, this.props.export?.excel?.sheetName);
                        }}

                    // onEditCanceled={this.props.onEditCanceled}
                    // onEditingStart={this.props.onEditingStart}
                    // onEditCanceling={this.props.onEditCanceled}
                    //onSaved={r =>this.forceUpdate()}
                    >
                        {this.props.multiSelect && this.props.allowChangeSelection !== false && <Selection mode='multiple' showCheckBoxesMode='always' />}
                        {false && <Selection mode='single' />}
                        {(this.props.paging !== false || this.props.pageSize > 0) &&
                            <Paging defaultPageSize={this.props.pageSize ?? 15}
                                //pageIndex={this.state.pageIndex}
                                onPageIndexChange={_ => this.setState({ /*pageIndex,*/ focusedRow: {} }, this.saveStates)}
                            />
                        }

                        {this.state.groupBy?.length > 0 && <Grouping key={this.state.groupBy} autoExpandAll={this.state.autoExpandAll} />}
                        <SearchPanel visible={this.props.noToolbar !== true} placeholder={'جستجو'} />
                        <HeaderFilter visible={this.props.headerFilter !== false} />
                        {this.props.filterPanel &&
                            <GFilterPanel visible={this.props.filterPanel !== false}
                                texts={{
                                    clearFilter: 'حذف فیلتر',
                                    createFilter: 'ایجاد فیلتر',
                                    filterEnabledHint: 'فیلتر فعال است'
                                }}
                            />
                        }
                        {this.props.filterBuilder !== false && <FilterBuilderPopup />}
                        <FilterRow visible={this.props.FilterRow !== false} />
                        <Scrolling mode='standard' rowRenderingMode scrollByThumb />
                        {this.props.groupBy?.length > 0 && <Grouping allowCollapsing autoExpandAll={this.props.autoExpandAll} />}

                        {false && <ScrollBar />}
                        <Export enabled={this.props.noToolbar !== true} formats={['pdf', 'word', 'excel']} allowExportSelectedData={true} />
                        {this.props.noToolbar !== true &&
                            <GToolbar>
                                {this.props.putTitleBoxInToolbar !== false &&
                                    <GToolbarItem location='before' render={this.renderTitleBox}
                                    />
                                }
                                {this.props.addToToolbar &&
                                    [...(this.props.addToToolbar?.length > 1 ? this.props.addToToolbar : [this.props.addToToolbar])
                                        .map(x => <GToolbarItem>{x}</GToolbarItem>)]
                                }

                                {this.state.parentFieldName?.length > 0 &&
                                    <GToolbarItem location='after'
                                        render={() => {
                                            return (
                                                <div style={{ marginLeft: '5px', height: '100%' }}>
                                                    <ButtonComp onClick={e => this.setState({ forceUseGrid: false })}
                                                        hint='نمایش درختی' height='100%'
                                                    >
                                                        <FontAwesomeIcon icon='chart-simple' fontSize='1rem' rotation={270} />
                                                    </ButtonComp>
                                                </div>
                                            );
                                        }}
                                    />
                                }

                                {this.props.allowAdding !== false && this.props.readOnly !== true &&
                                    <GToolbarItem name='addRowButton' />
                                }
                                <GToolbarItem name='exportButton' />
                                <GToolbarItem name='revertButton' />
                                <GToolbarItem name='searchPanel' />
                            </GToolbar>
                        }

                        <Sorting mode='single' ascendingText='مرتب سازی صعودی' descendingText='مرتب سازی نزولی' clearText='حذف مرتب سازی' />
                        <GStateStoring storageKey={this.sid + '_sort'}
                            type='localStorage' //type='custom'
                            customSave={this.saveStates}
                            customLoad={this.loadStatesA}
                            enabled//{false && this.props.saveState} 
                        />

                        {this.props.allowEditing !== false &&
                            <Editing
                                mode={this.props.editingMode ?? 'popup'}
                                allowUpdating={this.props.allowUpdating !== false && this.props.readOnly !== true}
                                allowAdding={this.props.allowAdding !== false && this.props.readOnly !== true}
                                allowDeleting={this.props.allowDeleting !== false && this.props.readOnly !== true}
                                useIcons={true}
                                onEditRowKeyChange={k => {
                                    let g = this.grid.instance;
                                    //console.log(k, typeof (k))

                                    g.editingRowKey = k;
                                    if (k === null && g.pastSelectedIndex >= 0) {
                                        g.option("focusedRowIndex", g.pastSelectedIndex);
                                    }
                                    else if (k !== null && !(k > 0)) {
                                        g.pastSelectedIndex = g.option("focusedRowIndex");
                                        //g.clearSelection();
                                        g.option("focusedRowIndex", -1);
                                    }
                                }}
                            >
                                <Popup title={"ورود اطلاعات " + (this.props.title ?? '')} showTitle={true}
                                    width={formWidth} height={this.props.popupHeight ?? 'auto'} // fit-content
                                    resizeEnabled={true} shading={true} shadingColor='rgba(0,0,0,0.5)'
                                    onHiding={this.props.onEditPopupHiding}
                                    onShowing={this.props.onEditPopupShowing
                                        ?? (() => {
                                            if (this.state.formMessage?.length > 0)
                                                this.setState({ formMessage: '' });
                                        })}
                                    onShown={e => {
                                        //console.log(this.grid.instance.editingRowKey);
                                        this.props.onEditPopupShown?.(e, this.grid.instance.editingRowKey);
                                    }}
                                    onHidden={e => {
                                        let g = this.grid.instance;
                                        if (g.pastSelectedIndex >= 0)
                                            g.option("focusedRowIndex", g.pastSelectedIndex);

                                        this.props.onEditPopupHidden?.(e, g.editingRowKey);
                                    }}
                                />

                                <Form ref={el => this.form = el} key={this.state.formMessage} colCount={formColCount}
                                    id={this.props.title + 'form'} height={this.props.formHeight ?? '70%'}
                                    onFieldDataChanged={console.log} {...this.props.editFormProps}
                                >
                                    {this.props.renderForm ? this.props.renderForm(this.state, this.grid) :
                                        columnsInfo?.filter(x => x.name !== '_sequence' && x.visible !== false && x.visible !== 'grid' && x.isHiddenAtForm != true)
                                            ?.map(x =>
                                            (
                                                // x.lookup?.length > 0 ?
                                                // <Form_Item name={x.name} dataField={x.name} key={x.name}
                                                //     //lookup={defLookupDataSource(x.lookup)}
                                                //     label={{ text: x.caption ?? x.name }}
                                                //     colSpan={x.colSpan > 0 ? x.colSpan : 1}
                                                // // editorOptions={{
                                                // //     readOnly: x.readOnly === true || x.readonly === true,
                                                // //     //editCellComponent: x.format === 'tarikh' || x.format === 3 ? TarikhPicker : undefined
                                                // // }}
                                                // // editorType={x.lookup?.length > 0 ? 'dxLookup' : undefined}
                                                // >
                                                //     <SelectBox dataSource={x.lookup} valueExpr='id' displayExpr='summary'
                                                //         //scrollByThumb
                                                //         //dropDownOptions={{ maxHeight: 500 }}
                                                //         readOnly={x.readOnly === true || x.readonly === true}
                                                //     />
                                                // </Form_Item> :
                                                <Form_Item name={x.name} dataField={x.name} key={x.name}
                                                    lookup={defLookupDataSource(x.lookup)}
                                                    label={{ text: x.caption ?? x.name }}
                                                    colSpan={x.colSpan > 0 ? x.colSpan : 1}
                                                    isRequired={x.required === true}
                                                    cssClass={x.rtl !== false && x.ltr !== true ? 'mdh-right-align' : 'mdh-left-align'}
                                                    rtlEnabled={x.rtl !== false && x.ltr !== true}

                                                    editorOptions={{
                                                        rtlEnabled: x.rtl !== false && x.ltr !== true,
                                                        readOnly: x.readOnly === true || x.readonly === true,
                                                        format: x.dataType == 'currency' ? { precision: 0, useCurrencyAccountingStyle: true } : undefined,

                                                        //editCellComponent: x.format === 'tarikh' || x.format === 3 || x.component === 'TarikhPicker' ? TarikhPicker : undefined
                                                    }}

                                                //editorType={!x.component ? undefined : 'TarikhPicker'}
                                                //itemType={!x.component ? undefined : 'TarikhPicker'}
                                                //render={!x.component ? undefined : frm => this.renderCustomComponent(frm, x)}

                                                //editorType={x.lookup?.length > 0 ? 'dxLookup' : undefined}
                                                />
                                            ))
                                    }
                                    {
                                        ...editingForm_ExtraItems
                                    }

                                    {this.state.formMessage?.length > 0 &&
                                        <SimpleItem colSpan={2}>
                                            <div style={{ color: 'red', background: 'yellow' }}>
                                                {this.state.formMessage}
                                            </div>
                                        </SimpleItem>
                                    }
                                </Form>
                            </Editing>
                        }

                        {this.props.allowChangeSelection === false && this.props.multiSelect &&
                            <Column caption='' calculateDisplayValue={row => this.props.selectedKeys?.includes(row.id) ? '✓' : ''}
                                width='2rem' alignment='center'
                            />
                        }
                        {/*this.props.table?.length > 0 &&*//**/ this.props.sequenceColumn !== false &&
                            <Column calculateDisplayValue={x => 1 + this.state.rows?.findIndex(r => r.id === x.id)}
                                name='_sequence' key='_sequence' dataField={undefined}
                                allowEditing={false} formItem={false}
                                width='5rem' alignment='center' caption='ردیف' allowSorting={true} fixedPosition={true} />
                        }

                        {this.props.rightButtonColumns?.map(b =>
                            <Column key={b.name} caption={b.caption} width={b.width ?? 'fit-content'}
                                cellRender={c => (b.useButton ?
                                    <Button width={b.width ?? '100%'} rowData={c.data}
                                        hint={b.hintOfRow?.(c.data) ?? b.hint}
                                        icon={b.iconOfRow?.(c.data) ?? b.icon}
                                        text={b.textOfRow?.(c.data) ?? b.text}
                                        disabled={b.disableIfRow?.(c.data) === true}
                                        {...b.props} className='ka-no-padding' style={{ ...this.props.buttonStyle }}
                                        onClick={() => b.onClick?.(c.data)}
                                        showBorders={false}
                                    /> // onClick={e => b.onClick?.(e.component._props.rowData)}
                                    :
                                    <i className={'dx-icon-' + (b.iconOfRow?.(c.data) ?? b.icon) + ' ka-no-padding'}
                                        style={btnCellStyle} onClick={e => b.onClick?.(c.data)}
                                    >{b.textOfRow?.(c.data) ?? b.text}
                                    </i>)
                                }>
                            </Column>
                        )}

                        {this.props.readOnly !== true &&
                            <Column type="buttons" width='5rem' >
                                {this.props.allowEditing && <Button name='redit' onClick={e => this.props.onEditButtonClick?.(x)} />}
                                {this.props.allowDeleting && <Button name='rdelete' onClick={e => this.props.onDeleteButtonClick?.(x)} />}
                            </Column>
                        }

                        {this.props.buttonColumns && this.props.buttonColumns.filter(x => x.locateAtBefore)?.map(b => //b &&
                            <Column key={b.name} caption={b.caption} width={b.width ?? 'fit-content'}
                                cellRender={c => (b.useButton ?
                                    <Button width={b.width ?? '100%'} rowData={c.data}
                                        {...b.props}
                                        hint={b.hintOfRow?.(c.data) ?? b.hint}
                                        icon={b.iconOfRow?.(c.data) ?? b.icon}
                                        text={b.textOfRow?.(c.data) ?? b.text}
                                        disabled={b.disableIfRow?.(c.data) === true}
                                        className='ka-no-padding' style={{ ...this.props.buttonStyle }}
                                        showBorders={false}
                                        onClick={e => b.onClick?.(c.data)}
                                    /> // onClick={e => b.onClick?.(e.component._props.rowData)}
                                    :
                                    <i className={'dx-icon-' + (b.iconOfRow?.(c.data) ?? b.icon) + ' ka-no-padding'}
                                        style={btnCellStyle} onClick={e => b.onClick?.(c.data)}
                                    >{b.textOfRow?.(c.data) ?? b.text}
                                    </i>)
                                }>
                            </Column>
                        )}

                        {columns.filter(x => x.visible !== false && x.visible !== 'form')}

                        {this.props.customColumns?.filter(cc => cc.visible !== false)?.map(cc =>
                            <Column key={cc.name ?? cc.caption} caption={cc.caption} width={cc.width ?? 'fit-content'}
                                cellRender={cc.cellRender}
                                {...cc.dxProps}
                            />)
                        }

                        {this.props.buttonColumns && this.props.buttonColumns.filter(x => !x.locateAtBefore)?.map(b => b &&
                            <Column key={b.name} caption={b.caption} width={b.width ?? 'fit-content'}
                                cellRender={c => (b.useButton ?
                                    <Button width={b.width ?? '100%'} rowData={c.data}
                                        {...b.props}
                                        hint={b.hintOfRow?.(c.data) ?? b.hint}
                                        icon={b.iconOfRow?.(c.data) ?? b.icon}
                                        text={b.textOfRow?.(c.data) ?? b.text}
                                        disabled={b.disableIfRow?.(c.data) === true}
                                        className='ka-no-padding' style={{ ...this.props.buttonStyle }}
                                        showBorders={false}
                                        onClick={e => b.onClick?.(c.data)}
                                    /> // onClick={e => b.onClick?.(e.component._props.rowData)}
                                    :
                                    <i className={'dx-icon-' + (b.iconOfRow?.(c.data) ?? b.icon) + ' ka-no-padding'}
                                        style={btnCellStyle} onClick={e => b.onClick?.(c.data)}
                                    >{b.textOfRow?.(c.data) ?? b.text}
                                    </i>
                                )
                                }>
                            </Column>
                        )}

                    </DataGridComp>
                }

                {this.props.contextMenuItems?.length > 0 &&
                    <ContextMenu rtlEnabled={!this.props.ltr}
                        key={this.state.focusedRow?.id}
                        dataSource={this.state.contextMenuItems}
                        width={200}
                        target={this.props.id ?? "#uniGridContainer_" + this.sid}
                        onItemClick={e => e.itemData?.command?.(this.state.focusedRow)}
                    />
                }
            </div>
        );
    }
}